<script setup>
import Button from '@components/global/button.vue'

defineProps(['item'])
</script>
<template>
	<Button simple class="card flex flex-col gap-6" :to="{ name: 'product', params: { slug: item.slug } }">
		<div class="relative flex h-[420px] w-full flex-col justify-between overflow-hidden rounded-2xl bg-bgSecondary p-6">
			<div class="flex flex-col gap-1 text-base">
				<span class="text-sm text-primaryLight">{{ item.type }}</span>
				<span>{{ item.name }}</span>
			</div>
			<img v-if="item.images?.length > 0" :src="item.images[0].url" class="animation aspect-square max-w-48 self-center object-contain scale-100" :alt="item.name" />
			<Button class="outlined" label="Learn more" />
		</div>
	</Button>
</template>
<style scoped>
.card:hover img {
	@apply scale-105;
}

.btn.card {
	@apply max-h-full p-0;
}
</style>
